import { staticAsset } from './staticAssets.js';
const img = staticAsset;
const sportImg = (path) => `/sport-icons${path.replace('/common/Showcase', '')}`;
const topEventImg = (sport) => `/top-events/${sport}.jpg`;

export const TOP_EVENT_SPORT_BG = {
  Football: topEventImg('football'),
  Hockey: topEventImg('hockey'),
  Tennis: topEventImg('tennis'),
  Basketball: topEventImg('basketball'),
  Esports: topEventImg('football'),
  'Table tennis': topEventImg('tennis'),
  Volleyball: topEventImg('volleyball'),
  Handball: topEventImg('handball'),
  'Mix. Fights': topEventImg('football'),
  Boxing: topEventImg('football'),
  'American football': topEventImg('football'),
  Baseball: topEventImg('baseball'),
  Rugby: topEventImg('football'),
  'Basketball 3x3': topEventImg('basketball'),
  Billiard: topEventImg('tennis'),
};

export const BANNER_SLIDES = [
  { title: 'Welcome bonus up to<br>100 TL + 300 FS', sub: 'For all new customers!', cta: 'Registration', ctaAction: 'welcome-landing', img: img('/content/Promo/tr/Welcome_bonus/5.Welcome_bonus_100FB_300FS_0126/action/1460_900_desk.webp'), showTime: 5 },
  { title: 'Hot Friday', sub: 'Bonus to deposit + free spins <br/>in one of three slot games!', cta: 'Get the bonus', ctaAction: 'promos', img: img('/content/Promo/tr/Casino_2026/7.July_2026/Main_slider_1460x900_6.webp'), showTime: 4 },
  { title: '7 000 000 TL<br> + 150 000 FS', sub: 'Get closer to the game with VurgunBet!', cta: 'More', ctaAction: 'promo', promoId: 'TR_CRM_ACT_World_Cup_2026', img: img('/content/Promo/tr/BIG_PROMO/World_cup_2026_7_000_000/Information_promo/Slider/Main_slider_1460x900_3.webp'), showTime: 5 },
  { title: '300 000 TL <br> + 15 000 FS', sub: 'In the War of Worlds tournament at VurgunBet!', cta: 'Participate', ctaAction: 'promo', promoId: 'TR_Tournament_Legendary_Race', img: img('/content/Promo/tr/BIG_PROMO/World_cup_2026_7_000_000/tournaments/casino/9.tour_War_of_Worlds_290626/Main_slider_1460x900.webp'), showTime: 5 },
  { title: '100 000 TL <br> + 10 000 FS', sub: 'In the Mundial of Victories tournament at VurgunBet!', cta: 'Participate', ctaAction: 'promo', promoId: 'TR_Tournament_Mundial', img: img('/content/Promo/tr/BIG_PROMO/World_cup_2026_7_000_000/tournaments/Main_slider_1460x900.webp'), showTime: 5 },
  { title: '20 000 TL<br/>in Live-casino', sub: 'In the Game of Suits tournament at VurgunBet!', cta: 'Participate', ctaAction: 'promo', promoId: 'TR_Tournament_Roulette_Magic', img: img('/content/Promo/tr/BIG_PROMO/World_cup_2026_7_000_000/tournaments/casino/3.tour_Game_of_Suits_080626/Main-slider-1460x900_11.webp'), showTime: 5 },
  { title: 'Cashback<br/>in Live-Casino', sub: 'Daily up to 7%!', cta: 'Get', ctaAction: 'promo', promoId: 'TR_Live_Casino_Cashback', img: img('/content/Promo/tr/Casino_2026/6.June_2026/1.Cashback_live-casino/Main_slider_1460x900_5.webp'), showTime: 5 },
  { title: 'VIP CASHBACK<br/>up to 25%', sub: 'Take advantage of privileges and get cashback every week!', cta: 'Details', ctaAction: 'promo', promoId: 'TR_VIP_Cashback_25', img: img('/content/Promo/tr/VIP_CASHBACK/2.Vip_cashback_update_new_design/Main_slider_1460x900.webp'), showTime: 5 },
  { title: 'Andrea Pirlo<br/>joins VurgunBet', sub: 'Feel the spirit of triumph!', cta: 'Play', ctaAction: 'casino', img: img('/content/Promo/tr/Slider_main/Andrea_Pirlo/Main_slider_1460x900.webp'), showTime: 5 },
  { title: 'Cashback 5%', sub: 'For each account replenishment via Papara!', cta: 'Top up the account', ctaAction: 'promo', promoId: 'TR_Papara_Cashback_5', img: img('/content/Promo/tr/Papara/update_design_december_2025/1460x900-en.webp'), showTime: 5 },
];

export const SHOWCASE_CARDS = [
  { id: 'slots', lobbyKey: 'slots', title: 'Slot-games', titleWidth: 140, count: '5463 games', link: 'View games →', linkWidth: 131, img: img('/content/Promo/Showcase/resources/new/Desktope/340x400.webp'), mobileImg: img('/content/Promo/Showcase/resources/new/Mobile/210x258.webp'), gradientFrom: '#d4004b', gradientTo: '#79002c', sport: false },
  { id: 'live', lobbyKey: 'live', title: 'Live-casino', titleWidth: 150, count: '219 games', link: 'Play now →', linkWidth: 109, img: img('/content/Promo/Showcase/resources/new/Desktope/340x400_11zon.webp'), mobileImg: img('/content/Promo/Showcase/resources/new/Mobile/210x258_11zon.webp'), gradientFrom: '#d4004b', gradientTo: '#79002c', sport: false },
  { id: 'tv', lobbyKey: 'tv', title: 'TV-games', titleWidth: 150, count: '16 games', link: 'Play now →', linkWidth: 109, img: img('/content/Promo/Showcase/resources/new/Desktope/340x400_1.webp'), mobileImg: img('/content/Promo/Showcase/resources/new/Mobile/210x258_1.webp'), gradientFrom: '#d4004b', gradientTo: '#79002c', sport: false },
  { id: 'fast', lobbyKey: 'fast', title: 'Fast games', titleWidth: 150, count: '48 games', link: 'Play now →', linkWidth: 109, img: img('/content/Promo/Showcase/resources/new/Desktope/340x400.webp'), mobileImg: img('/content/Promo/Showcase/resources/new/Mobile/210x258.webp'), gradientFrom: '#d4004b', gradientTo: '#79002c', sport: false },
  { id: 'virtual', lobbyKey: 'virtual', title: 'Virtual sports', titleWidth: 170, count: '32 games', link: 'Play now →', linkWidth: 109, img: img('/content/Promo/Showcase/resources/new/Desktope/340x400_1.webp'), mobileImg: img('/content/Promo/Showcase/resources/new/Mobile/210x258_1.webp'), gradientFrom: '#d4004b', gradientTo: '#79002c', sport: false },
  { id: 'sport', title: 'Sport', titleWidth: 100, count: '3380 events', link: 'Bet now →', linkWidth: 155, img: img('/content/Promo/Showcase/resources/new/Desktope/340x400_2.webp'), mobileImg: img('/content/Promo/Showcase/resources/new/Mobile/690x300.webp'), gradientFrom: '#79002c', gradientTo: '#d4004b', sport: true },
];

export const CASINO_CATEGORIES = ['Slots', 'Live-casino', 'TV-games', 'Fast games', 'Virtual sports'];

const gr8 = (name) => {
  const src = img(`/content/Casino/categories/gr8/${name}.png`);
  return { icon: src, iconActive: src };
};

export const CASINO_TABS = [
  { id: 'review', label: 'Review', ...gr8('tab-review') },
  { id: 'top', label: 'Top games', ...gr8('tab-top') },
  { id: 'all', label: 'All games', ...gr8('tab-all') },
  { id: 'jackpot-cards', label: 'Jackpot Cards', ...gr8('tab-bingo') },
  { id: 'new', label: 'NEW', ...gr8('tab-new') },
  { id: 'buy-bonus', label: 'Buy Bonus', ...gr8('tab-buy-bonus') },
  { id: 'exclusive', label: 'Exclusive', ...gr8('tab-exclusive') },
  { id: 'jackpot', label: 'Jackpot', ...gr8('tab-jackpot') },
  { id: 'retro', label: 'Retro', ...gr8('tab-retro') },
  { id: 'books', label: 'Books', ...gr8('tab-books') },
];

const G = staticAsset('/casino-assets/games_New');

export const CASINO_ROWS = [
  { title: 'Slots', gameCount: '5448', games: [
    { name: 'Diamonds Power XXL: Hold And Win', provider: 'Playson', img: `${G}/Playson/DiamondsPowerXXLHoldandWin.webp`, badge: null },
    { name: 'Fawkes', provider: 'Wicked Games', img: `${G}/WickedGames/Fawkes.webp`, badge: 'exclusive' },
    { name: 'Gates of Olympus Super Scatter', provider: 'Pragmatic Play', img: `${G}/PragmaticPlay/GatesofOlympusSuperScatter.webp`, badge: 'tournament' },
    { name: 'Book del Sol: Multiplier', provider: 'Playson', img: `${G}/Playson/BookdelSol_Multiplier.webp`, badge: null },
    { name: "Indiana's Quest", provider: 'Evoplay', img: `${G}/Evoplay/IndianasQuest.webp`, badge: null },
    { name: '20 Hot Blast', provider: 'Amusnet', img: `${G}/Amusnet/20HotBlast.webp`, badge: 'jackpot' },
    { name: 'Brute Force: Alien Onslaught', provider: 'NoLimit City', img: `${G}/NoLimitCity/BruteForce-AlienOnslaught.webp`, badge: null },
    { name: 'Madame Destiny Megaways', provider: 'Pragmatic Play', img: `${G}/PragmaticPlay/MadameDestinyMegaways.webp`, badge: 'top' },
    { name: '3 Coin Volcanoes', provider: '3 Oaks', img: `${G}/3OAKS/3CoinVolcanoes.webp`, badge: null },
    { name: 'Animal Quest', provider: 'Evoplay', img: `${G}/Evoplay/AnimalQuest.webp`, badge: null },
    { name: 'Punk Rocker 2', provider: 'NoLimit City', img: `${G}/NoLimitCity/BruteForce-AlienOnslaught.webp`, badge: null },
    { name: 'Candy Palace', provider: 'Amusnet', img: `${G}/Amusnet/20HotBlast.webp`, badge: 'exclusive' },
    { name: 'The DogHouse Megaways', provider: 'Pragmatic Play', img: `${G}/PragmaticPlay/MadameDestinyMegaways.webp`, badge: null },
  ]},
  { title: 'Live-casino', gameCount: '219', games: [
    { name: 'Madame Destiny Megaways', provider: 'Pragmatic Play', img: `${G}/PragmaticPlay/MadameDestinyMegaways.webp`, badge: 'top' },
    { name: '3 Coin Volcanoes', provider: '3 Oaks', img: `${G}/3OAKS/3CoinVolcanoes.webp`, badge: null },
    { name: 'Animal Quest', provider: 'Evoplay', img: `${G}/Evoplay/AnimalQuest.webp`, badge: null },
    { name: 'Diamonds Power XXL: Hold And Win', provider: 'Playson', img: `${G}/Playson/DiamondsPowerXXLHoldandWin.webp`, badge: null },
    { name: 'Gates of Olympus Super Scatter', provider: 'Pragmatic Play', img: `${G}/PragmaticPlay/GatesofOlympusSuperScatter.webp`, badge: null },
  ]},
  { title: 'TV-games', gameCount: '16', games: [
    { name: 'Fawkes', provider: 'Wicked Games', img: `${G}/WickedGames/Fawkes.webp`, badge: null },
    { name: 'Book del Sol: Multiplier', provider: 'Playson', img: `${G}/Playson/BookdelSol_Multiplier.webp`, badge: null },
    { name: '20 Hot Blast', provider: 'Amusnet', img: `${G}/Amusnet/20HotBlast.webp`, badge: null },
    { name: 'Animal Quest', provider: 'Evoplay', img: `${G}/Evoplay/AnimalQuest.webp`, badge: null },
  ]},
  { title: 'Fast games', gameCount: '48', games: [
    { name: 'Brute Force: Alien Onslaught', provider: 'NoLimit City', img: `${G}/NoLimitCity/BruteForce-AlienOnslaught.webp`, badge: null },
    { name: '3 Coin Volcanoes', provider: '3 Oaks', img: `${G}/3OAKS/3CoinVolcanoes.webp`, badge: null },
    { name: 'Madame Destiny Megaways', provider: 'Pragmatic Play', img: `${G}/PragmaticPlay/MadameDestinyMegaways.webp`, badge: null },
    { name: 'Fawkes', provider: 'Wicked Games', img: `${G}/WickedGames/Fawkes.webp`, badge: null },
  ]},
  { title: 'Virtual sports', gameCount: '32', games: [
    { name: 'Diamonds Power XXL: Hold And Win', provider: 'Playson', img: `${G}/Playson/DiamondsPowerXXLHoldandWin.webp`, badge: null },
    { name: 'Gates of Olympus Super Scatter', provider: 'Pragmatic Play', img: `${G}/PragmaticPlay/GatesofOlympusSuperScatter.webp`, badge: null },
    { name: 'Animal Quest', provider: 'Evoplay', img: `${G}/Evoplay/AnimalQuest.webp`, badge: null },
    { name: '20 Hot Blast', provider: 'Amusnet', img: `${G}/Amusnet/20HotBlast.webp`, badge: null },
  ]},
];

export const PROMO_CATEGORIES = ['Promotions', 'Tournaments'];
export const PROMO_FILTERS = ['All', 'Sport (5)', 'Casino (5)'];
export const PROMO_PAGE_FILTERS = [
  { id: 'all', label: 'All' },
  { id: 'casino', label: 'Casino', icon: 'casino' },
  { id: 'sport', label: 'Sport', icon: 'sport' },
];

export const PROMOS = [
  {
    id: 'world-cup',
    promoId: 'TR_CRM_ACT_World_Cup_2026',
    caption: 'Get closer to the game',
    title: '7 000 000 TL<br> + 150 000 FS <br>to the 2026 World Cup',
    detailTitle: '7,000,000 TL + 150,000 FS at VurgunBet',
    detailSubtitle: 'FIFA World Cup 2026!',
    img: img('/content/Promo/tr/BIG_PROMO/World_cup_2026_7_000_000/Information_promo/Promo/Widget_890h400.webp'),
    bannerImg: img('/content/Promo/tr/BIG_PROMO/World_cup_2026_7_000_000/Information_promo/Promo/1200x375_1.webp'),
    heroImg: img('/content/Promo/tr/BIG_PROMO/World_cup_2026_7_000_000/Information_promo/Slider/Main_slider_1460x900_3.webp'),
    bg: '#55000a',
    type: 'sport',
    terms: [
      'Take part in promotions, place sports bets, play casino games, and earn bonuses! Detailed terms and conditions for receiving bonuses are published in the “Promos” section on the day the promotion begins.',
      'The maximum bonus amount for the “Big Game” promotion is 3,000,000 TL. Promotion period: June 11, 2026, through July 19, 2026.',
      'Casino tournaments with a total bonus pool of 2,000,000 TL + 90,000 free spins. Duration: June 8, 2026, to July 19, 2026.',
      'Total bonus fund for the “Road to the Final” promotion – 1,400,000 TL! Duration: June 11, 2026 – July 19, 2026.',
      'The total bonus fund for the “World Cup of Victories” promotion is 600,000 TL + 60,000 free spins. Promotion period: June 8, 2026, to July 19, 2026.',
    ],
  },
  {
    id: 'welcome',
    promoId: 'TR_CRM_NC_welcome_freebet100_freespins300',
    modalType: 'welcome-landing',
    caption: 'WELCOME BONUS',
    title: 'Free bet up to<br>100 TL + 300 FS',
    sub: 'Play in style!',
    detailTitle: 'Free bet up to 100 TL + 300 FS',
    landingTitle: '100 TL + 300 FS',
    detailSubtitle: 'Play in style!',
    img: img('/content/Promo/tr/Welcome_bonus/5.Welcome_bonus_100FB_300FS_0126/action/890h400_2.webp'),
    heroImg: img('/content/Promo/tr/Welcome_bonus/5.Welcome_bonus_100FB_300FS_0126/action/1460_900_desk.webp'),
    landingImg: img('/content/Promo/tr/Welcome_bonus/5.Welcome_bonus_100FB_300FS_0126/action/update/360h660_eng.webp'),
    bg: '#000000',
    type: 'sport',
    terms: [
      'Offer available to new customers who register and make their first deposit.',
      'Free bet is credited after the qualifying deposit is settled.',
      'Free spins are available in selected slot games for 7 days after crediting.',
      'Minimum odds and wagering requirements apply to the free bet.',
    ],
  },
  {
    id: 'predictions',
    promoId: 'TR_World_Cup_Predictions',
    caption: 'ROAD TO THE FINAL',
    title: '250 000 TL<br>for correct predictions<br>on the 2026 World Cup',
    timer: '8 hours left',
    detailTitle: '250 000 TL for correct predictions on the 2026 World Cup',
    detailSubtitle: 'Make your picks and win your share of the prize pool!',
    img: img('/content/Promo/tr/BIG_PROMO/World_cup_2026_7_000_000/predictions/Widget_890h400.webp'),
    heroImg: img('/content/Promo/tr/BIG_PROMO/World_cup_2026_7_000_000/predictions/Widget_890h400.webp'),
    bg: '#000000',
    type: 'sport',
    terms: [
      'Submit predictions before the deadline shown on the promotion page.',
      'Only one prediction set per customer per round is allowed.',
      'Prizes are shared among customers with the highest number of correct outcomes.',
      'Winners are notified within 72 hours after the final match of the round.',
    ],
  },
  {
    id: 'oplati',
    promoId: 'TR_Papara_Cashback_5',
    caption: 'CASHBACK OPLATI',
    title: '5% cashback <br> on every deposit',
    detailTitle: '5% cashback on every deposit via Papara',
    detailSubtitle: 'Top up your account and get cashback automatically!',
    img: img('/content/Promo/tr/Papara/update_design_december_2025/890x320-en-436.webp'),
    heroImg: img('/content/Promo/tr/Papara/update_design_december_2025/1460x900-en.webp'),
    bg: '#49000b',
    type: 'sport',
    terms: [
      'Cashback applies to deposits made through the Papara payment system.',
      '5% of each qualifying deposit is returned to the main account.',
      'Cashback is credited within 24 hours after the deposit is confirmed.',
      'Minimum deposit amount and maximum cashback per day may apply.',
    ],
  },
  {
    id: 'live-cashback',
    promoId: 'TR_Live_Casino_Cashback',
    caption: 'Live-cashback',
    title: 'Get cashback <br> up to 7% <br> at Live-casino',
    detailTitle: 'Get cashback up to 7% at Live-casino',
    detailSubtitle: 'Daily cashback on your Live-casino activity!',
    img: img('/content/Promo/tr/Casino_2026/6.June_2026/1.Cashback_live-casino/Widget_890h400_1.webp'),
    heroImg: img('/content/Promo/tr/Casino_2026/6.June_2026/1.Cashback_live-casino/Main_slider_1460x900_5.webp'),
    bg: '#000000',
    type: 'casino',
    terms: [
      'Cashback is calculated on net losses in Live-casino games during the day.',
      'Maximum cashback percentage depends on your activity level.',
      'Cashback is credited the next calendar day before 12:00 UTC+3.',
      'Only real-money bets in participating Live-casino tables qualify.',
    ],
  },
  {
    id: 'vip',
    promoId: 'TR_VIP_Cashback_25',
    caption: 'VIP CASHBACK',
    title: 'Cashback<br>up to 25%<br>every week!',
    detailTitle: 'Cashback up to 25% every week!',
    detailSubtitle: 'Take advantage of privileges and get cashback every week!',
    img: img('/content/Promo/tr/VIP_CASHBACK/2.Vip_cashback_update_new_design/Widget_890h320.jpg'),
    heroImg: img('/content/Promo/tr/VIP_CASHBACK/2.Vip_cashback_update_new_design/Main_slider_1460x900.webp'),
    bg: '#232323',
    type: 'casino',
    terms: [
      'VIP cashback is available to customers who reach the required VIP status level.',
      'Cashback percentage depends on your VIP tier and weekly activity.',
      'Cashback is credited every Monday for the previous week.',
      'VIP status and cashback terms may be revised by VurgunBet at any time.',
    ],
  },
];

export const TOURNAMENT_PROMOS = [
  {
    id: 'legendary-race',
    promoId: 'TR_Tournament_Legendary_Race',
    name: 'Legendary Race',
    prizeMain: '300 000 TL',
    prizeSub: '+ 15 000 FS',
    participants: '3 592',
    places: '800',
    daysLeft: '6 days',
    active: true,
    caption: 'Tournament',
    title: '300 000 TL <br> + 15 000 FS',
    detailTitle: '300 000 TL + 15 000 FS',
    detailSubtitle: 'Legendary Race tournament',
    cardImg: img('/content/Promo/tr/BIG_PROMO/World_cup_2026_7_000_000/tournaments/casino/10.tour_Legendary_Race_060726/720x400.webp'),
    widgetImg: img('/content/Promo/tr/BIG_PROMO/World_cup_2026_7_000_000/tournaments/casino/10.tour_Legendary_Race_060726/Widget_890h320.webp'),
    img: img('/content/Promo/tr/BIG_PROMO/World_cup_2026_7_000_000/tournaments/casino/10.tour_Legendary_Race_060726/720x400.webp'),
    heroImg: img('/content/Promo/tr/BIG_PROMO/World_cup_2026_7_000_000/tournaments/casino/10.tour_Legendary_Race_060726/720x400.webp'),
    bg: '#000000',
    type: 'casino',
    icon: 'compass',
    terms: [
      'Tournament runs for the period stated on the promotion page.',
      'Points are awarded for qualifying bets in participating slot games.',
      'Prize pool is shared among top-ranked participants on the leaderboard.',
      'Free spins prizes are credited within 48 hours after the tournament ends.',
    ],
  },
  {
    id: 'roulette-magic',
    promoId: 'TR_Tournament_Roulette_Magic',
    name: 'Roulette Magic',
    prizeMain: '20 000 TL',
    participants: '430',
    places: '100',
    daysLeft: '6 days',
    active: true,
    caption: 'Tournament',
    title: '20 000 TL',
    detailTitle: '20 000 TL',
    detailSubtitle: 'Roulette Magic tournament',
    cardImg: img('/content/Promo/tr/BIG_PROMO/World_cup_2026_7_000_000/tournaments/casino/7.tour_Roulette_Magic/720x400.webp'),
    widgetImg: img('/content/Promo/tr/BIG_PROMO/World_cup_2026_7_000_000/tournaments/casino/7.tour_Roulette_Magic/Widget_890h320.webp'),
    img: img('/content/Promo/tr/BIG_PROMO/World_cup_2026_7_000_000/tournaments/casino/7.tour_Roulette_Magic/720x400.webp'),
    heroImg: img('/content/Promo/tr/BIG_PROMO/World_cup_2026_7_000_000/tournaments/casino/7.tour_Roulette_Magic/720x400.webp'),
    bg: '#000000',
    type: 'casino',
    icon: 'badge',
    terms: [
      'Tournament applies to selected roulette tables in Live-casino.',
      'Points are calculated based on qualifying real-money bets.',
      'Leaderboard updates in real time during the tournament period.',
      'Prizes are paid within 72 hours after the final leaderboard is confirmed.',
    ],
  },
  {
    id: 'lucky-plane',
    promoId: 'TR_Tournament_Lucky_Plane',
    name: 'Lucky Plane',
    prizeMain: '20 000 TL',
    participants: '757',
    places: '100',
    daysLeft: '6 days',
    active: true,
    caption: 'Tournament',
    title: '20 000 TL',
    detailTitle: '20 000 TL',
    detailSubtitle: 'Lucky Plane tournament',
    cardImg: img('/content/Promo/tr/BIG_PROMO/World_cup_2026_7_000_000/tournaments/casino/2.tour_Lucky_Plane_080626/720x400.webp'),
    widgetImg: img('/content/Promo/tr/BIG_PROMO/World_cup_2026_7_000_000/tournaments/casino/2.tour_Lucky_Plane_080626/Widget_890h320.webp'),
    img: img('/content/Promo/tr/BIG_PROMO/World_cup_2026_7_000_000/tournaments/casino/2.tour_Lucky_Plane_080626/720x400.webp'),
    heroImg: img('/content/Promo/tr/BIG_PROMO/World_cup_2026_7_000_000/tournaments/casino/2.tour_Lucky_Plane_080626/720x400.webp'),
    bg: '#000000',
    type: 'casino',
    icon: 'crown',
    terms: [
      'Tournament runs in selected fast games.',
      'Points are awarded for qualifying bets during the tournament period.',
      'Prize pool is shared among top-ranked participants.',
      'Winners are notified within 72 hours after the tournament ends.',
    ],
  },
  {
    id: 'mundial',
    promoId: 'TR_Tournament_Mundial',
    name: 'Mundial of Victories',
    prizeMain: '100 000 TL',
    prizeSub: '+ 10 000 FS',
    participants: '1 277',
    places: '600',
    daysLeft: '6 days',
    active: true,
    caption: 'Tournament',
    title: '100 000 TL <br> + 10 000 FS',
    detailTitle: '100 000 TL + 10 000 FS',
    detailSubtitle: 'In the Mundial of Victories tournament at VurgunBet!',
    cardImg: img('/content/Promo/tr/BIG_PROMO/World_cup_2026_7_000_000/tournaments/720h400.webp'),
    img: img('/content/Promo/tr/BIG_PROMO/World_cup_2026_7_000_000/tournaments/720h400.webp'),
    heroImg: img('/content/Promo/tr/BIG_PROMO/World_cup_2026_7_000_000/tournaments/Main_slider_1460x900.webp'),
    bg: '#55000a',
    type: 'sport',
    icon: 'sport',
    terms: [
      'Participation is open to all registered VurgunBet customers.',
      'Points are earned for qualifying bets on World Cup 2026 events.',
      'Leaderboard updates in real time during the tournament period.',
      'Cash prizes are credited to the main account; FS to selected slots.',
    ],
  },
];

export const ALL_PROMOS = [...PROMOS, ...TOURNAMENT_PROMOS];

export function getPromoByPromoId(promoId) {
  if (!promoId) return null;
  return ALL_PROMOS.find((p) => p.promoId === promoId || p.id === promoId) || null;
}

const sportGradient = 'linear-gradient(180deg, #708199 0%, #475466 100%)';
const racingGradient = 'linear-gradient(180deg, #7c8ca4 0%, #505e71 100%)';

export const SPORT_WIDGET_LIVE = {
  id: 'live',
  live: true,
  gradient: 'linear-gradient(180deg, #DB4944 0%, #AB1A39 100%)',
  icon: sportImg('/common/Showcase/live_desktop.png'),
  iconW: 110,
  iconH: 110,
  iconBottom: 0,
  names: [{ text: 'Live', top: 8, live: true }],
  typeTop: 34,
};

export const SPORT_WIDGET_CARDS = [
  {
    id: 'wc2026',
    gradient: 'linear-gradient(rgb(124, 140, 164) 0%, rgb(80, 94, 113) 100%)',
    icon: sportImg('/common/Showcase/desk_WorldCup2026.webp'),
    names: [{ text: 'World Cup 2026', top: 8 }],
    type: 'Football',
    typeTop: 34,
  },
  {
    id: 'epl',
    gradient: sportGradient,
    icon: sportImg('/common/Showcase/turkish_super_league_desktop.png'),
    names: [{ text: 'Premier League', top: 8 }],
    type: 'Football',
    typeTop: 34,
  },
  {
    id: 'wimbledon-w',
    gradient: sportGradient,
    icon: sportImg('/common/Showcase/wimbledon_desktop.png'),
    names: [{ text: 'Wimbledon', top: 8 }],
    type: 'Tennis (W)',
    typeTop: 34,
  },
  {
    id: 'wimbledon-m',
    gradient: sportGradient,
    icon: sportImg('/common/Showcase/wimbledon_desktop.png'),
    names: [{ text: 'Wimbledon', top: 8 }],
    type: 'Tennis (M)',
    typeTop: 34,
  },
  {
    id: 'u19',
    gradient: sportGradient,
    icon: sportImg('/common/Showcase/UEFA_Under19_desk.png'),
    iconW: 90,
    iconH: 90,
    names: [{ text: 'U19 European Championship', top: 8 }],
    type: 'Football',
    typeTop: 34,
  },
  {
    id: 'xse',
    gradient: sportGradient,
    icon: sportImg('/common/Showcase/XSE_Pro_League_desk.png'),
    names: [{ text: 'XSE Pro', top: 8 }, { text: 'League 2026', top: 27 }],
    type: 'Counter-Strike',
    typeTop: 51,
  },
  {
    id: 'f1',
    gradient: racingGradient,
    icon: sportImg('/common/Showcase/NewColors_Red/f1_desk.png'),
    iconBottom: -5,
    names: [{ text: 'Formula 1', top: 8 }, { text: 'British Grand Prix', top: 28 }],
    type: 'Racing',
    typeTop: 52,
  },
  {
    id: 'nations',
    gradient: sportGradient,
    icon: sportImg('/common/Showcase/desk_VNL_1.png'),
    names: [{ text: 'Nations League', top: 8 }],
    type: 'Volleyball',
    typeTop: 34,
  },
  {
    id: 'ewc',
    gradient: sportGradient,
    icon: sportImg('/common/Showcase/desk_ewc2025.png'),
    names: [{ text: 'Esports World Cup', top: 8 }],
    type: 'Valorant',
    typeTop: 34,
  },
];

export const SPORTS = SPORT_WIDGET_CARDS.map((c) => ({
  name: c.names.map((n) => n.text).join(' '),
  type: c.type,
}));

export const SPORT_LABEL_COLORS = {
  Football: '#619a38',
  Hockey: 'rgb(26, 86, 120)',
  Tennis: 'rgb(140, 112, 0)',
  Basketball: 'rgb(180, 90, 20)',
  Esports: 'rgb(100, 70, 130)',
  'Table tennis': 'rgb(16, 120, 100)',
  Volleyball: 'rgb(40, 110, 150)',
  Handball: 'rgb(35, 120, 80)',
  'Mix. Fights': 'rgb(120, 40, 40)',
  Boxing: 'rgb(140, 40, 35)',
  Baseball: 'rgb(140, 40, 35)',
  Rugby: 'rgb(30, 110, 70)',
  'Basketball 3x3': 'rgb(180, 90, 20)',
  'American football': 'rgb(150, 60, 0)',
  Billiard: 'rgb(20, 130, 110)',
};

export const TOP_EVENT_FILTERS = [
  { id: 'top', label: 'En İyi' },
  { id: 'football', label: 'Football' },
  { id: 'hockey', label: 'Hockey' },
  { id: 'tennis', label: 'Tennis' },
  { id: 'basketball', label: 'Basketball' },
  { id: 'esports', label: 'Esports' },
  { id: 'table_tennis', label: 'Table tennis' },
  { id: 'volleyball', label: 'Volleyball' },
  { id: 'handball', label: 'Handball' },
  { id: 'mix_fights', label: 'Mix. Fights' },
  { id: 'boxing', label: 'Boxing' },
  { id: 'baseball', label: 'Baseball' },
  { id: 'am_football', label: 'American football' },
  { id: 'rugby', label: 'Rugby' },
  { id: 'basketball_3x3', label: 'Basketball 3x3' },
  { id: 'billiard', label: 'Billiard' },
];

export { TOP_EVENTS } from './topEventsSeed';
